import React, { Component } from 'react';
import PropTypes from 'prop-types';


/**
 * This Slider component can have it's value set both externally
 * (via props.value) and internally via user interaction (dragging the slider
 * needle).
 *
 * Whenever the internal value changes, the props.onChange handler
 * is called with the new value.
 */
class Slider extends Component {
  state = {
    value: 0,
  }

  constructor(props) {
    super(props);
    this.sliderRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  onWindowResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    });
  }

  componentDidMount() {
    this.setState({
      value: this.props.value,
    });

    window.addEventListener('resize', this.onWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  /**
   * Converts state.value to a left pixel offset used to corretly
   * position the needle.
   */
  getNeedleLeft = () => {
    if (!this.sliderRef.current) {
      return 0;
    }

    const slider = this.sliderRef.current;
    const trackWidth = slider.offsetWidth - 17;
    return this.state.value * trackWidth;
  }

  render() {
    const { label } = this.props;

    return (
      <div className="slider" ref={this.sliderRef}>
        <div className="slider__label">{label}</div>
        <div className="slider__needle"
          style={{ left: `${this.getNeedleLeft()}px` }}
          onMouseDown={this.onNeedleMouseDown}
          onTouchMove={this.onTouchMove}
        ></div>
        <div className="slider__progress"
          style={{ width: `${this.state.value * 100}%` }}></div>
      </div>
    );
  }

  onNeedleMouseDown = () => {
    document.onmousemove = (e) => {
      this.onNeedleDrag(e.clientX);
    };

    document.onmouseup = () => {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }

  onTouchMove = (e) => {
    this.onNeedleDrag(e.touches[0].clientX);
  }

  onNeedleDrag = (clientX) => {
    let x = clientX;
    const slider = this.sliderRef.current;

    // Not exactly sure of the circumstances but occasionally this reference
    // was null
    if (!slider) {
      return;
    }

    // Width minus the approx width of needle
    const trackWidth = slider.offsetWidth - 17;
    const minX = slider.getBoundingClientRect().left;
    const maxX = minX + trackWidth;

    if (x < minX) {
      x = minX;
    }

    if (x > maxX) {
      x = maxX;
    }

    const newValue = (x - minX) / trackWidth;
    this.setState({
      value: newValue,
    });
    // Call the parent onChange handler know about the new value
    this.props.onChange(newValue);
  }
}

Slider.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  value: PropTypes.number,
};

export default Slider;
